// unit: filter
import f from "../../../funcs";


/**
     * Condition - Условие/Параметр для фильтров
     * @constructs Condition
     * @param  {Object} params параметры, объект вида: смотри в пример
     * @example <caption>Condition params</caption>
     * {
     *   // Тип условия
     *   type: {String}
     *   // Возможные значения
     *      date,
     *      contain,
     *      in,
     *      equal
     *
     *   // Ключ поля
     *   key: {String}
     *   // Любое значение (зависит от типа)
     *   value: {*}
     * }
     *
     * // P.S.  В зависимости от типа объект может содержать и другие св-ва
     */
let Condition = f.CreateClass("Condition");

Condition.prototype.init = function(params) {
    params = params || {};

    /*
         // ОБЯЗАТЕЛЬНЫЙ
         this.key; // ключ столбца
         // ОБЯЗАТЕЛЬНЫЙ
         this.type; // тип фильтра

         // инверсия
         this.not;
         // отсеим пустые значения если === false
         this.withNulls;

         // equal, in, contain
         this.value;

         // date params:
         this.intervals;

         // compoiste params:
         this.values;
         this.notValues;
         this.search;
         */
    params = f.deepClone(params);

    for (let key in params) {
        this[key] = params[key];
    }

    if ( f.isArray(this.intervals) ) {
        this.intervals = this.intervals.map(function(obj) {
            if ( f.isObject(obj) ) {
                obj = f.deepClone(obj);
                obj.start = +f.parseDate(obj.start).date;
                obj.end = +f.parseDate(obj.end).date;
            }

            return obj;
        });
    }
};

Condition.prototype.setKey = function(key) {
    this.key = key;
};

Condition.prototype.setType = function(type) {
    this.type = type;
};

Condition.prototype.setValue = function(value) {
    this.value = value;
};

Condition.prototype["compile2.0"] = function() {
    return JSON.parse(JSON.stringify({ // удаляем undefined
        noRows: this.noRows,
        not: this.not,
        key: f.deepClone(this.key),
        type: this.type,
        value: this.value,
        search: this.search,
        values: this.values,
        notValues: this.notValues,
        intervals: this.intervals,
        withNulls: this.withNulls,
        onlyNulls: this.onlyNulls,
        withoutSearch: this.withoutSearch,
        multiLang: this.multiLang
    }));
};

/**
     * Компилятор в серверные фильтры почти 3 версии
     */
Condition.prototype["compile2.9"] = function() {
    try {
        if ( !this.key )
        {throw new Error ("Filter.Condition:CompileError: filter without key");}

        switch (this.type) {
            case "equal":
                return compileEqualCond.call(this);
            case "composite":
                return compileCompositeCond.call(this);
            case "date":
                return compileDateCond.call(this);
            case "in":
                return compileInCond.call(this);

            case "contain":
                return compileContainCond.call(this);
            default:
                throw new Error("Filter.Condition:CompileError: unknown filter type, " + this.type);
        }
    }
    catch (error) {
        console.log(error.name, error.message);
        return;
    }

    function compileEqualCond() {
        return this.not ? [this.key, "!=", this.value] : [this.key, "=", this.value];
    }

    function compileDateCond() {
        return this.not ? ["!", [this.key, "inRange", this.intervals]] : [this.key, "inRange", compileIntervals.call(this)];
    }

    function compileInCond(not) {
        return not || this.not ? ["!", [this.key, "in", this.notValues]] : [this.key, "in", this.values || this.value];
    }

    function compileContainCond() {
        return this.not ? ["!", [this.key, "contain", this.value]] : [this.key, "contain", this.value];
    }

    function compileCompositeCond() {
        let resultCond = [];

        if ( this.onlyNulls === true ) {
            return compileOnlyNulls.call(this);
        }

        if ( this.withNulls === false ) {
            return compileWithoutNulls.call(this);
        }

        if ( this.search ) {
            resultCond.push(compileContainCond.call(this));
        }

        if ( this.notValues ) {
            resultCond.push(compileInCond.call(this, true));
        }

        if ( this.values ) {
            resultCond.push(compileInCond.call(this));
        }

        if ( this.noRows ) {
            resultCond.push(compileConflictCond.call(this)); ///Хитрожопый фильтр с кофликтом по id который вернет 0 строк
        }

        if ( resultCond.length === 1 ) {
            return resultCond[0];//разворачивает лишние скобки
        }

        let result = [];
        resultCond.forEach(function(cond, i) {
            result.push(cond);

            if ( i != resultCond.length - 1 ) {
                result.push("and");
            }
        },this);

        return result;
    }
    //Мб эта функция ничем не отличается от компилятора версии 1.1 или f.isDateDistance
    //Но в планах есть добавление возможности использования интервалов без end или старт
    //Пусть пока побудет в таком виде
    //TODO: Инициализация интервалов из строки, числа и без end || start
    function compileIntervals() {
        if ( !f.isArray(this.intervals) ) {
            throw new Error ("Filter.Condition:CompileError: bad date intervals on " + this.key);
        }
        let dates = this.intervals.map(function(dateInterval) {
            let date = {};
            let end = dateInterval.end;
            let start = dateInterval.start;

            if ( !start || !end ) {
                throw new Error("Filter.Condition:CompileError: bad date interval on " + this.key);
            }

            date.end = f.isNumber(end) ? new Date(end).toISOString() : f.parseDate(end).date.toISOString();
            date.start = f.isNumber(start) ? new Date(start).toISOString() : f.parseDate(start).date.toISOString();
            return date;
        }, this);
        return dates;
    }

    function compileConflictCond() {
        return [["ID", "!=", 1],"and",["ID", "=", 1]];
    }
    function compileWithoutNulls() {
        return [this.key, "is", "not null"];
    }
    function compileOnlyNulls() {
        return [this.key, "is", "null"];
    }
};

function checkDateInterval2version__1_1(interval) {
    if ( !f.isDateDistance(interval) ) {
        throw new Error("Filter.Condition:CompileError: bad interval " + interval);
    }
    return interval;
}

/**
     * Костыль (определение)
     * Эти поля встречаются только у компаний.
     * Сервер выдает ошибку, если передавать массив строк.
     */
const KEYS_IN = ["ROLE", "ROLE_A_B", "ROLE_RIGHTS", "MANAGERS_IDS_AND_OWNER"];

Condition.prototype["compile1.1"] = function() {
    let result;

    if ( this.type == "equal" ) {
        result = {
            values: [this.value]
        };
    } else if ( this.STATUS_NEW ) {
        if ( this.STATUS_NEW.type == "equal" ) {
            result = {
                values: [this.STATUS_NEW.value] };
        }
    } else if ( this.type == "in" ) {
        // Костыль (реализация)
        if ( KEYS_IN.includes(this.key) ) {
            result = {
                values: this.value.map(function(v) {
                    return +v;
                })
            };
        } else if ( this.value == "all" ) {
            result = { values: "all" };
        } else {
            result = {
                values: this.value.map(function(v) {
                    return v + "";
                })
            };
        }
    } else if ( this.type == "date" && f.isArray(this.intervals) ) {
        result = {
            values: this.intervals.map(checkDateInterval2version__1_1)
        };
    } else if ( this.type == "contain" && f.isString(this.value) ) {
        result = {
            values: "all",
            search: this.value
        };

        if ( this.multiLang ) result.multiLang = true;
    } else if ( this.type == "composite" ) {
        result = {};
        if ( this.search ) result.search = this.search;

        if ( this.withoutSearch ) result.withoutSearch = this.withoutSearch;

        if ( this.multiLang ) result.multiLang = this.multiLang;

        if ( this.notValues ) {
            result.not = true;
            result.values = this.notValues;
        } else if ( this.values ) {
            result.values = this.values;
        }

        if ( this.onlyNulls ) {
            result = { onlyNulls: true };
        }
    }

    else if ( !this.noRows ) {
        throw new Error("Filter.Condition:CompileError: condition not supported or invalid", this);
    }

    if ( this.noRows ) {
        result.noRows = true;
    }

    if ( this.not ) {
        result.not = true;
    }

    if ( this.withNulls === false ) {
        result.withNulls = false;
    } else if ( this.withNulls === true ) {
        result.withNulls = true;
    }

    return result;
};

Condition.prototype.compile2version = function(version) {
    if ( !f.isFunction(this["compile" + version]) ) {
        throw new Error("Filter.Condition:VersionError: version " + version + " has not suppoerted");
    }
    return this["compile" + version]();
};

// в итоге оно переводится на другие языки
// eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
Condition.YES = "Да";
// eslint-disable-next-line no-cyrillic-string/no-cyrillic-string
Condition.NO = "Нет";
let interval = setInterval(() => {
    if ( window.langDictionary ) {
        clearInterval(interval);

        Condition.YES = window.langDictionary.get("Yes");
        Condition.NO = window.langDictionary.get("No");
    }
});

/**
     * Проверяем, подходит ли модель под этот параметр поиска.
     * !!! this.search и this.value должны быть в нижнем регистре, если это поиск по подстроке (оптимизация)
     * @return {Boolean}
     */
Condition.prototype.check = function(model) {
    let key = this.key;
    let isKeyModule = ( this.key === "module" );
    let value = this.value;
    let modelValue = model.get(key);
    let valueType = model.getType && model.getType(key);
    let modelValueText = model.getText && !isKeyModule ? model.getText(key) : modelValue;
    let type = this.type;
    let result = true;

    if ( this.withNulls === false && modelValue == null ) {
        // отсеиваем только null и undefined.
        // остальные значения потипу: false, '' не должны сюда попадать
        result = false;
    }
    // если ползьователь ищет пустые и не только
    else if ( this.withNulls === true && modelValue == null ) {
        result = true;
    }

    // аналогично для SQL: " WHERE x in (1, 2, 3) "
    else if ( type == "in" ) {
        if ( f.isArray(modelValue) ) {
            // for ROLE
            result = checkIn(modelValue, this.value);
        } else {
            // for checkbox
            result = checkIn(modelValueText, this.value);
        }
    }

    // сравнение строк
    else if ( type == "equal" ) {
        if ( f.isArray(modelValue) && !f.isArray(value) ) { // ROLE
            result = checkIn(modelValue, [value]);
        }
        else if ( valueType == "checkbox" ) {
            let tmpEqValue = value;
            if ( tmpEqValue == Condition.YES ) {
                tmpEqValue = 1;
            }
            else if ( tmpEqValue == Condition.NO ) {
                tmpEqValue = 0;
            }

            if ( modelValue != tmpEqValue ) {
                result = false;
            }
        }
        // virtual field in form
        else if ( valueType === undefined && modelValueText === undefined ) {
            if ( modelValue != value ) {
                result = false;
            }
        }
        else if ( modelValueText != value ) {
            result = false;
        }
    } else if ( type == "date" && f.isArray(this.intervals) ) {
        result = checkInteravls(modelValue, this.intervals);
    } else if ( type == "contain" ) {
        result = !this.multiLang
            ? f.likeStr(modelValueText + "", value)
            : f.likeStr(modelValueText + "", f.eng2rus(value))
                    || f.likeStr(modelValueText + "", f.rus2eng(value));
    }

    // совмещает в себе date, contain, in по AND,
    // нужен для ColumnFilter
    else if ( type == "composite" ) {
        result = true;

        if ( this.search && !this.withoutSearch ) {
            result = !this.multiLang
                ? result && f.likeStr(modelValueText + "", this.search)
                : result && (
                    f.likeStr(modelValueText + "", f.eng2rus(this.search))
                        || f.likeStr(modelValueText + "", f.rus2eng(this.search))
                );
        }

        let values;
        let valuseResult;

        if ( this.values instanceof Array ) {
            values = this.values;
        }

        if ( this.notValues instanceof Array ) {
            values = this.notValues;
        }

        if ( values ) {
            if ( f.isObject(values[0]) ) {
                valuseResult = checkInteravls(modelValue, values);
            } else if ( valueType == "checkbox" || valueType == "minute" ) {
                valuseResult = checkIn(modelValue, values);
            } else {
                valuseResult = checkIn(modelValueText, values);
            }

            if ( this.notValues ) {
                valuseResult = !valuseResult;
            }

            result = result && valuseResult;
        }

        // ищем только пустые строки
        if ( !this.search && !values && this.withNulls || this.onlyNulls ) {
            result = modelValue == null;
        }
    }

    if ( this.noRows ) {
        return false;
    }

    // инверсия
    return this.not === true ? !result : result;
};

/**
     * проверяем, что условие для поиска всегда будет возвращать true,
     * а значит его можно будет потом удалить
     * p.s. 20.05.2016 10:43 метод использовался только в columnFilter
     * для очистки красного значка на пустом фильтре
     * @return {Boolean} true, если this.check( anyModel ) === true
     */
Condition.prototype.isEmpty = function() {
    let isEmpty = false;

    if ( this.noRows ) {
        return false;
    }

    if ( this.withNulls === false ) {
        return false;
    }

    if ( this.type == "composite" ) {
        isEmpty = !this.search
                && (!this.values || !this.values.length)
                && (!this.notValues || !this.notValues.length) && !this.onlyNulls;
    } else if ( this.type == "contain" ) {
        isEmpty = !this.value;
    } else if ( this.type == "in" ) {
        isEmpty = !this.value || !this.value.length;
    } else if ( this.type == "equal" ) {
        // equal можно использовать для поиска пустых значений,
        // поэтому он всегда не пустой
    } else if ( this.date == "date" ) {
        isEmpty = !this.intervals || !this.intervals.length;
    }
    if ( !this.type ) {
        isEmpty = true;
    }

    return isEmpty;
};

Condition.prototype.merge = function(condition) {
    for (let key in condition) {
        this[key] = condition[key];
    }
};

function checkInteravls(modelValue, intervals) {
    let interval;
    let result = false;
    modelValue = +f.parseDate(modelValue).date;

    for (let i = 0, n = intervals.length; i < n; i++) {
        interval = intervals[i];
        //похорошему надо вынести toComparable()
        interval.start = f.isString(interval.start) ? +f.parseDate(interval.start).date : interval.start;
        interval.end = f.isString(interval.end) ? +f.parseDate(interval.end).date : interval.end;
        if ( interval.start <= modelValue && interval.end >= modelValue ) {
            result = true;
            break;
        }
    }

    return result;
}

function checkIn(modelValue, values) {
    let result = false;
    let value;

    for (let i = 0, n = values.length; i < n; i++) {
        value = values[i];

        if ( value == modelValue ) {
            result = true;
            break;
        }

        // ROLE is array
        // f.isArray - замедляет в 10 раз !!!
        else if ( modelValue instanceof Array ) {
            for (let j = 0, m = modelValue.length; j < m; j++) {
                if ( value == modelValue[j] ) {
                    result = true;
                    break;
                }
            }

            if ( result ) {
                break;
            }
        }
    }

    return result;
}

export default Condition;
